import React from 'react'
import { Button } from 'react-bootstrap'
import './Inputs.css'

interface IButtonProp {
  href?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
  children?: any
}

const RedButton: React.FC<IButtonProp> = ({
  href,
  onClick,
  disabled,
  style,
  className,
  children,
}: IButtonProp) => {
  return (
    <Button
      type='button'
      className={'btn btn-red btn-round ' + className}
      onClick={onClick}
      href={href}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
export default RedButton
